import { render } from "./MapperV2Job.vue?vue&type=template&id=480f1aa6"
import script from "./MapperV2Job.vue?vue&type=script&lang=js"
export * from "./MapperV2Job.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__